import React from "react";
import {
	Box,
	Container,
	Flex,
	Heading,
	IconButton,
	Img,
	Text,
	Link,
	OrderedList,
	ListItem,
	Divider,
} from "@chakra-ui/react";
import { FaLinkedin } from "react-icons/fa";

const linkedInUrl = "https://www.linkedin.com/in/apoorva-sharma-06874679/";

const FundInFocusDec: React.FC = () => (
	<>
		{/* members */}
		<Flex
			as="section"
			flexDirection="column"
			overflow="hidden"
			justify="center"
			height={{ xs: "450px", sm: "300px" }}
			minH={{ xs: "450px", sm: "300px" }}
			maxH="450px"
			pos="relative"
		>
			<Img
				pos="absolute"
				objectFit="cover"
				src="/jpg/blogBanner.jpg"
				alt="members-hero"
				height="100%"
				width="100%"
			/>
			<Box
				bg="linear-gradient(93.48deg, #00001F 45.8%, #186658 74.6%)"
				pos="absolute"
				height="100%"
				width="100%"
				opacity="0.7"
			/>
			<Container
				maxW="container.xl"
				position="relative"
				zIndex="1"
				flexDir="column"
				px={{ xs: "20px", sm: "28px", md: "45px", lg: "60px", xl: "inherit" }}
			>
				<Heading
					as="h1"
					mb="20px"
					variant="reportCardTitle"
					fontSize={{ xs: "26px", sm: "28px", md: "32px", lg: "38px" }}
					color="white"
					lineHeight={{ xs: "34px", md: "39px", lg: "42px" }}
				>
					FUND IN FOCUS: Seizing the ‘India Opportunity&apos;, Stride Ventures
					Sees Growth in EV, Fintech, and Consumer Sectors
				</Heading>
			</Container>
		</Flex>
		<Container
			as="section"
			maxW="container.xl"
			pb="80px"
			pt="40px"
			minH="420px"
			display={{ xs: "flex", md: "inherit" }}
			flexDirection="column"
		>
			<Box as="main" w="100%" pb="40px">
				<Text variant="blogAnswer">
					Welcome to our ‘Fund in Focus’ series where we profile our member
					funds, underscore their investment philosophy, and highlight some of
					their interesting work. Today we speak to{" "}
					<Link
						href={linkedInUrl}
						target="_blank"
						style={{
							textDecoration: "underline",
						}}
						rel="noreferrer"
					>
						Apoorva Sharma{" "}
					</Link>
					, Managing Partner at Strides Ventures - India&apos;s most active
					Venture Debt fund. She shares insights on their guiding principles,
					transformative impact on start-ups, and sectoral growth predictions.
					Explore their unique risk assessment, adaptive strategies, and the
					role of technology in financial inclusion. Discover emerging industry
					trends, the team&apos;s banking expertise, and the holistic support
					provided beyond capital. Gain valuable perspectives on exit
					strategies, global ambitions, and success stories, showcasing Stride
					Ventures&apos; pivotal role in shaping India&apos;s start up
					ecosystem.{" "}
				</Text>
			</Box>

			<Img
				src="https://static.levocdn.com/WGLBUT82/7143599310986525092.jpg"
				alt="Apoorva"
				boxSize="300px"
				float={{ xs: "right", md: "left" }}
				alignSelf={{ xs: "center", md: "flex-start" }}
				mx={{ xs: "0px", md: "0px" }}
				mr={{ xs: "0px", md: "40px", lg: "60px", xl: "70px" }}
				mb="20px"
				objectFit="cover"
				rounded="full"
			/>
			<Flex flexDir={{ xs: "column", lg: "row" }} rowGap="16px">
				<Heading
					textAlign={{ xs: "center", md: "left" }}
					fontWeight="800"
					color="blue.400"
				>
					Spokesperson: Apoorva Sharma, Managing Partner at Stride Ventures
				</Heading>
				<Flex
					columnGap={{ xs: "4px", md: "16px" }}
					justifyContent={{ xs: "center", md: "flex-start" }}
					transform={{ xs: "translateX(12px)", md: "none" }}
				>
					<Box alignSelf="center">
						<Link href={linkedInUrl} target="_blank">
							<IconButton
								aria-label="linkedin"
								icon={
									<FaLinkedin size="28px" color="rgba(100, 100, 140, 0.6)" />
								}
								variant="unstyled"
								cursor="pointer"
							/>
						</Link>
					</Box>
				</Flex>
			</Flex>
			<Box>
				<Box
					ml={{ xs: "auto", md: "345px", lg: "370px" }}
					mr={{ xs: "auto", md: "0px" }}
					width={{ xs: "160px", md: "80px" }}
					h="2px"
					bgColor="primary.500"
					borderRadius="5px"
					mt={{ xs: "16px", md: "10px" }}
					mb="15px"
				/>
				<Box mt="16px" mb="20px">
					<Heading variant="blogQuestion" mb="20px">
						1.What guiding principles underpin Stride Ventures&apos; venture
						debt investments, especially in growth-stage companies?
					</Heading>
					<Text variant="blogAnswer">
						Stride Ventures is the most active Venture Debt fund in India. The
						company offers customized and founder-friendly debt solutions to new
						age businesses empowering them to allocate capital strategically. We
						have pioneered innovative alternative solutions to cater to the
						unique needs of startups and growth-stage businesses. Venture Debt
						provides startups with an alternative financing option to fuel their
						growth without diluting equity.
						<br />
						<br />
						Stride&apos;s has transformed the financing landscape for startups
						in India, offering them working capital, capex, acquisition
						financing through the fund business and custom-made supply chain
						financing solutions through Stride One.
						<br />
						<br />
						<b>Impact:</b> By providing venture debt under the
						entrepreneur-first approach, we secure the interest of the Founder
						and help startups bridge their funding gaps, extend their runway,
						and accelerate their growth. This has had a transformative impact on
						their ability to scale, attract further investments, and achieve key
						milestones. Stride Ventures has (~30%) one of the largest market
						shares in the sector, which is an indication of how successful it
						has been in identifying a financing gap and penetrating the startup
						ecosystem. The fund boasts a well-diversified portfolio of 120+
						companies across various sectors. It has demonstrated
						industry-leading returns with best-in-class asset quality and a
						portfolio of market leaders like SUGAR Cosmetics, The Good Glamm
						Group, Mensa Brands, Exotel, MoneyView, VideoVerse, BluSmart, Lohum,
						Miko, Perfios, HealthifyMe, Ace Turtle and Waycool to name a few.
						<br />
						<br />
					</Text>
				</Box>
				{/* Question 2 */}
				<Box my="16px">
					<Heading variant="blogQuestion" pb="20px" pt="12px">
						2.As a VD fund, what&apos;s your take on the ‘India Opportunity’?
						Which sectors according to you will be significant growth drivers
						for the Indian economy?
					</Heading>
					<Text variant="blogAnswer" pt="16px">
						Global value chains (GVCs) are currently undergoing significant
						changes, influenced by three major trends predating the pandemic:
						the rise of new technologies, the urgent need for environmental
						sustainability in response to climate change, and the evolving
						nature of globalization. The COVID-19 pandemic has further
						accelerated these shifts. In response, international companies are
						revising their manufacturing, supply chain, and investment
						strategies to enhance resilience, opening doors for new regions to
						become preferred locations.
						<br />
						<br />
						India stands as a strong contender to seize this opportunity. The
						country&apos;s advantages include the potential for substantial
						domestic demand, proactive government policies promoting
						manufacturing, and a unique demographic advantage. Furthermore,
						India is actively encouraging all sectors to generate employment for
						its rapidly expanding workforce, aiming to distribute economic
						growth more evenly and manage its trade deficit more effectively.
						There is a visible excitement around ESG focused ventures across the
						board in categories such as EV, clean-tech etc. We are witnessing
						startups aimed at balancing profitability and sustainability in
						their business models.
						<br />
						<br />
						India is one of the fastest growing fintech markets globally. India
						has a set of open APIs through the India stack including eKYC,
						Adhaar, Digi Locker and UPI. This makes it easier to build
						businesses on top of the digital architecture.
						<br />
						<br />
						Stride is poised to be the largest EV financing institution for
						Indian startups. This will further drive India&apos;s EV sector
						towards its 2030 goal of 16-17 million sales. We provide tailored
						financial solutions to startups, aiding scalability and easing
						capital acquisition. Our strategies, emphasizing efficient and
						founder-friendly financing, facilitate innovation, sustainable
						growth and equity protection. Examples like BluSmart in our
						portfolio highlight our role in enabling startups to compete
						effectively in challenging EV market segments.
						<br />
						<br />
						The consumer sector has been one of the prime focus areas for
						Stride. India has seen increased consumerism with many domestic
						brands coming up across BPC, Apparel, Food and Beverages etc. Stride
						boasts 35+ category leaders in its portfolio across different
						consumer sectors
						<br />
						<br />
					</Text>
				</Box>

				{/* Question 3 */}
				<Box my="16px">
					<Heading variant="blogQuestion" pt="28px">
						3. How does your fund approach risk assessment in this unique
						investment space?
					</Heading>
					<Text variant="blogAnswer" mt="16px" mb="8px">
						Venture debt is a loan to new-age businesses. We back category
						leaders that have fundamentally strong business models and are
						well-capitalized with backing from marquee institutional investors.
						We stay away from sectors that have regulatory overhang like crypto,
						real money gaming etc.
						<br />
						<br />
						Mostly, Venture debt investing starts after a company at an early
						stage has raised over $5 million from venture capital and when the
						company generates Rs 2-3 crore per month in revenues. These
						companies have less leverage with the standard being less than 5% of
						valuation. They should also have a runway of over 9-12 months at the
						time of our investment.
						<br />
						<br />
						We also keep our investors in view while developing investment
						strategies. Venture debt yields recurrent, tangible, and foreseeable
						returns, akin to fixed-income investments. Thus, various classes of
						investors, including domestic investment offices, family treasuries,
						and analogous entities, have been showing great enthusiasm.
						<br />
					</Text>
				</Box>

				{/* Question 4 */}
				<Box my="16px">
					<Heading variant="blogQuestion" pt="16px">
						4. How does Stride Ventures stay agile and adapt to market trends
						and shifts in the venture debt landscape?
					</Heading>
					<Text variant="blogAnswer" py="16px">
						We keep active track of the market and adopt an entrepreneur-first
						approach and an institutional framework towards funding and
						financing solutions. What that means is we deliver solutions which
						protect against equity erosion and tap into use-case scenarios of
						debt/credit solutions to enhance scalability and stability.
						<br />
						<br />
						As pioneers of debt/credit solutions in India we are actively
						increasing the opportunity size by educating startup founders and
						last-mile entrepreneurs who are a vital part of the value chain.
						Stride is also reimagining banking solutions for the last-mile
						entrepreneurs, vendors, farmers and suppliers of Indian startups and
						MSMEs with StrideOne.
						<br />
						<br />
						Aligned with his larger mission of fueling India&apos;s
						entrepreneurial promise through financial inclusion, we found that
						the answer to this barrier to access to finance for MSMEs lies in
						technology. In 2022, we launched StrideOne, a tech-led financial
						services platform for MSMEs and startup supply chains to drive
						financial inclusion for both. StrideOne will allow supply chain
						partners of startups like MSME entrepreneurs to grow alongside the
						upcoming unicorns of India. A more comprehensive opportunity size
						can be analysed from the StrideOne report
						<Link
							href="https://origin.strideone.in/wp-content/uploads/2022/12/Startup-Economy-Report-2022-by-StrideOne.pdf?var=20072024"
							target="_blank"
							style={{ color: "blue", textDecoration: "underline" }}
						>
							{" "}
							‘The Startup Economy Report 2022’.
						</Link>
						<br />
						<br />
						We seek collaborative opportunities with the public policy and
						government stakeholders of our country. The support of the macro
						policy becomes essential to scale innovative business models like
						the need for public infrastructure to support the amplification of
						EV adoption across all formats and business categories.
						<br />
					</Text>
					{/* <OrderedList listStyleType="upper-alpha">
            <ListItem>
              <Text variant="blogAnswer" pl={{ md: '12px', lg: '18px' }}>
                <b>Science-led Innovation:</b>
                <br />
                This is based on fundamental research and often originates from
                academic labs of universities or researchers who have worked in
                R&D departments of large corporates for several years. They push
                the boundaries of science, and can be categorized as new
                discoveries. We are one of the earliest and largest investors in
                Bugworks Research - a great example of this. Bugworks has
                platform technology combining medicinal chemistry, structural
                biology, and computational modelling that has given rise to
                multiple drug assets to tackle the global problem of AMR
                (antimicrobial resistance) and oncology. They recently became
                the first company in the world in Phase 1 stage to partner with
                Global Antibiotic R&D Partnership (GARDP), an initiative by
                World Health Organization.
                <br />
                <br />
                Another example is our portfolio The ePlane Company, which is
                building the most compact eVTOL aircrafts in the world to
                address of the problem of mid-mile mobility and logistics. The
                startup was incubated at IIT Madras and its work is based on
                decades of research in aerospace by Dr. Satya Chakravarthy, a
                professor at IIT Madras.
                <br />
              </Text>
            </ListItem>
            
            <ListItem>
              <Text variant="blogAnswer" pl={{ md: '12px', lg: '18px' }}>
                <b> Engineering-led Innovations:</b> <br />
                They combine elements of engineering, design, software,
                mathematics, and other fields to make the product work in the
                real world. Our portfolio company Tricog Health falls in this
                bucket. Tricog offers AI-driven analysis of ECGs
                (electrocardiogram) and echocardiograms to diagnose heart
                diseases in India, SEA and Africa, touching 12 million patients.
                They combine decades of experience in cardiology, embedded
                systems, and deep learning. Similarly, UTEC’s portfolio Agara
                that leveraged deep learning to build fully autonomous voice
                agents for customer support was acquired by Coinbase in 2021.
                <br />
              </Text>
            </ListItem>
          </OrderedList> */}
				</Box>
				{/* Question 5 */}
				<Box my="16px">
					<Heading variant="blogQuestion" pt="16px">
						5. What are the emerging trends in the industry that you foresee
						influencing your future investments?
					</Heading>
					<Text variant="blogAnswer" py="16px">
						Entrepreneurs are looking for protection against equity erosion and
						maintaining scalability through Stride Ventures funding solutions
						and new-age financing solutions under an institutional framework to
						help build resilient business models.
						<br />
						<br />
						In 2022, venture debt worth $800 million was deployed in India, and
						it is anticipated that this figure may increase to $3-5 billion
						within the next five years. Venture debt disbursals in India rose
						49% year-on-year in 2022. The Indian venture ecosystem has
						significant growth ahead of it this decade, and venture debt will
						play a vital role in enabling this growth. A more comprehensive
						opportunity size can be analysed from the Stride Ventures
						<Link
							href="https://s3.ap-south-1.amazonaws.com/www.strideventures.in/India+Venture+Debt+Report+2023.pdf"
							target="_blank"
							style={{ color: "blue", textDecoration: "underline" }}
						>
							{" "}
							‘The India Venture Debt Report 2023’.
						</Link>
						<br />
						<br />
						<b> StrideOne perspective-</b> According to the World Bank appraisal
						document for the Raising and Accelerating MSME Performance
						<Link
							href="https://pib.gov.in/PressReleasePage.aspx?PRID=1777170#:~:text=As%20per%20the%20World%20Bank,Recovery%20initiatives%20of%20the%20Government."
							target="_blank"
							style={{ color: "blue", textDecoration: "underline" }}
						>
							{" "}
							(RAMP)
						</Link>{" "}
						programme, over 40% of MSMEs lack access to formal sources of
						finance. As a result of the lack of proper accounting systems,
						updated financials, and proper documentation, a large number of MSME
						borrowers are excluded from the traditional lending ecosystem. For
						India to step confidently into the future, servicing the credit
						needs of India&apos;s 60 million MSMEs without any access to formal
						credit is paramount. The meteoric rise of startups also showcases
						the immense potential for Indian MSMEs to grow alongside these
						new-age businesses. Today, India is the 3rd largest startup
						ecosystem in the world, this has significantly impacted the Indian
						economy and showcases the ability to contribute approximately 4-5%
						to the GDP of India.
						<br />
					</Text>
				</Box>
				{/* Question 6 */}
				<Box my="16px">
					<Heading variant="blogQuestion" pt="16px">
						6. With your team&apos;s banking experience, how do you leverage
						this unique perspective in evaluating potential investments and
						assisting portfolio companies?
					</Heading>
					<Text variant="blogAnswer" py="16px">
						We are the most active venture debt fund in India. This is achieved
						by leveraging the Stride team&apos;s cumulative team experience
						exceeding 100 years.
						<br />
						<br />
						Stride Ventures, the firm has become the most active lender in the
						Indian startup ecosystem. The venture debt firm boasts a
						well-diversified sector-agnostic portfolio of 120+ companies,
						sanctioning over 4000 cr. The team has consecutively received
						prestigious awards like ‘Venture Debt Fund Of The Year’ for its role
						in introducing and pioneering alternative funding in India.
						<br />
						<br />
						Our in-house technology team is innovating tech-enabled underwriting
						and full-stack customised solutions for not just funding but
						financial solutions that become part of the business
						model/operations.
						<br />
						<br />
						The institutional framework at Stride supports all financial
						functions of both budding and unicorn businesses. We are the most
						reliable allies for entrepreneurs. We work closely with teams to
						build solutions bespoke to their needs, and now together with
						StrideOne, we are supporting both funding and financing needs. This
						approach makes us a partner of the entrepreneurs, helping them build
						and scale their businesses without equity erosion. This is made
						possible by the team&apos;s collective strengths to enable the
						required pace of execution and innovation.
						<br />
					</Text>
				</Box>

				{/* Question 7 */}
				<Box my="16px">
					<Heading variant="blogQuestion" pt="16px">
						7. In what ways does Stride Ventures provide support and value
						beyond capital to its portfolio companies? Can you share any
						specific instances of this?
					</Heading>

					<OrderedList listStyleType="upper-alpha">
						<ListItem>
							<Text variant="blogAnswer" pl={{ md: "12px", lg: "18px" }}>
								Support and enable public and private partnerships, this
								empowers our portfolio companies to scale in unison alongside
								the required public infrastructure.
							</Text>
						</ListItem>
						<ListItem>
							<Text variant="blogAnswer" pl={{ md: "12px", lg: "18px" }}>
								We also enable collaborations among our portfolios to support
								ecosystem synergies. We help them synergize and use each
								other&apos;s services.
							</Text>
						</ListItem>
						<ListItem>
							<Text variant="blogAnswer" pl={{ md: "12px", lg: "18px" }}>
								We are also giving wings to the global ambitions of Indian
								entrepreneurs by supporting them with funding, global
								networking, and collaboration opportunities. We took some of our
								best companies to Abu Dhabi in Feb 2023 and got them to meet the
								sovereign funds in that region to give them access to global
								capital.
							</Text>
						</ListItem>
						<ListItem>
							<Text variant="blogAnswer" pl={{ md: "12px", lg: "18px" }}>
								Stride One is a unique platform that allows financing to the
								ecosystem of the start up in addition to balance sheet debt
								through Stride Ventures. This enables the start-up’s
								distributors, retailers, and vendors to access credit.
							</Text>
						</ListItem>
						<ListItem>
							<Text variant="blogAnswer" pl={{ md: "12px", lg: "18px" }}>
								We help our portfolio companies get bank debt at the best
								possible rates to reduce the blended cost of financing for them.
							</Text>
						</ListItem>
					</OrderedList>
				</Box>

				{/* QUestion 8 */}
				<Box my="16px">
					<Heading variant="blogQuestion" pt="16px">
						8. What exit strategies does Stride Ventures typically consider when
						partnering with portfolio companies? Can you share a notable success
						story related to this?
					</Heading>
					<Text variant="blogAnswer" py="16px">
						In venture debt, the debentures are self-liquidating, so we get the
						money back as per the repayment schedules. In warrant positions, we
						actively manage exits on a quarterly basis. We have exited one of
						the highest warrant positions in the industry, which shows the focus
						we have to generate tangible and good returns from capital gains. We
						have exited warrants in companies like Bizongo, Aknamed, ProgCap and
						Sugar and made a good upside.
					</Text>
				</Box>
			</Box>
			<Divider borderWidth="1px" borderColor="black" />
			<Heading
				variant="blogQuestion"
				lineHeight="30px"
				pt="16px"
				fontStyle="italic"
				p="12px 12px 0px"
			>
				The content in this section is curated by Team IVCA. For any feedback,
				connect with&nbsp;
				<Link
					href="mailto:paromita.sinha@ivca.in"
					target="_blank"
					style={{ color: "blue", textDecoration: "underline" }}
				>
					paromita.sinha@ivca.in
				</Link>
			</Heading>
		</Container>
	</>
);

export default FundInFocusDec;
